import React, { Component } from "react";
import axios from "axios";
import Helmet from "react-helmet";
import moment from "moment-timezone";
import queryString from "query-string";
import Select from "react-select";
import Calendar from "react-calendar/dist/umd/Calendar";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";
import Layout from "../../../Layout/layout";
import { apiHost } from "../../../api/apiClient";
import { here_api_key } from "../../../utils/mapapi";
import locationCache from "../../../utils/locationCache";
import { getValidTemperature, temperatureReadingClass } from "../../../utils/temperature";
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";
import "../../../styles/realTime/realTime.scss";
import "../../../styles/reports/reports.scss";
import "../../../styles/tools/colors.scss";
import "./replay.scss";

const VIRTUAL_STOP_MINUTES = 5;

const getSelectedTimeZone = (fallback) => localStorage.getItem("timeZoneID") || fallback || moment.tz.guess() || "Australia/Melbourne";

const formatHeading = (heading) => {
  const value = Number(heading);
  if (!Number.isFinite(value)) return "-";
  const dirs = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"];
  const normalized = ((value % 360) + 360) % 360;
  return `${Math.round(normalized)}° ${dirs[Math.round(normalized / 45) % 8]}`;
};

const formatDateTime = (value, tzName) => {
  if (!value) return "-";
  const date = moment(value);
  if (!date.isValid()) return "-";
  return tzName ? date.tz(tzName).format("DD-MMM-YY HH:mm:ss z") : date.format("DD-MMM-YY HH:mm:ss");
};

const formatNumber = (value, digits = 1, suffix = "") => {
  const number = Number(value);
  if (!Number.isFinite(number)) return "-";
  return `${number.toFixed(digits)}${suffix}`;
};

const getRecordLat = (record) => Number(record && (record.lat ?? record.Lat));
const getRecordLng = (record) => Number(record && (record.lng ?? record.Lng));
const isTruthyFlag = (value) => value === true || value === 1 || value === "1" || String(value).toLowerCase() === "true";
const isCarryInOvernightStop = (stop) => stop && stop.type === "real" && stop.overnight && Number(stop.startIdx) === 0;
const haversineMeters = (lat1, lng1, lat2, lng2) => {
  const toRadians = (value) => value * Math.PI / 180;
  const earthRadiusM = 6371000;
  const latDelta = toRadians(lat2 - lat1);
  const lngDelta = toRadians(lng2 - lng1);
  const a = Math.sin(latDelta / 2) ** 2
    + Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(lngDelta / 2) ** 2;
  return earthRadiusM * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};
const escapeMarkup = (value) => String(value || "").replace(/[&<>"']/g, (character) => ({
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
}[character]));

class Replay extends Component {
  constructor(props) {
    super(props);
    const values = queryString.parse(props.location.search);
    const selectedDate = values.selectedDate || values.SearchDate || values.searchDate || values.assetDate || moment().format("YYYY-MM-DD");
    this.state = {
      assetId: values.assetId || values.AssetId || values.id || "",
      assetName: values.assetName || values.AssetName || values.name || "",
      selectedDate,
      date: moment(selectedDate).isValid() ? moment(selectedDate).toDate() : new Date(),
      calendarSelectedDate: moment(selectedDate).isValid() ? moment(selectedDate).toDate() : new Date(),
      dataPlaceholder: moment(selectedDate).isValid() ? moment(selectedDate).format("dddd Do MMMM, YYYY") : moment().format("dddd Do MMMM, YYYY"),
      calendarShow: false,
      tzName: getSelectedTimeZone(values.tz || values.timeZone),
      groupDetails: [],
      groupId: values.groupId || values.GroupId || "",
      AssetList: [],
      assetLoader: false,
      groupLoader: false,
      records: [],
      stops: [],
      selectedStopIndex: null,
      currentIndex: 0,
      isPlaying: false,
      playbackSpeed: 1,
      isLoading: false,
      errorMessage: "",
      replayData: null,
      depot: null,
      loadedReportParams: null,
      pickerExpanded: false,
      zoomLevel: 7,
      mapReady: false,
      erpEnabled: false,
      erpMapped: false,
      erpLoading: false,
      erpError: "",
      erpStops: [],
      erpGeofences: [],
      erpMatches: {},
      erpOverlayVisible: true,
      activeStopsTab: "stops",
      selectedErpStopIndex: null,
    };
    this.map = null;
    this.platform = null;
    this.mapUi = null;
    this.routeLine = null;
    this.depotOverlay = null;
    this.depotInfoBubble = null;
    this.movingMarker = null;
    this.stopMarkers = [];
    this.erpMapObjects = [];
    this.playbackTimer = null;
    this.mapContainer = null;
    this.mapResizeObserver = null;
    this.mapResizeTimers = [];
    this.routeFitTimers = [];
    this.groupId = this.state.groupId;
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.loadGroups();
    this.initMap();
    if (this.state.assetId) {
      this.loadReplay();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    window.removeEventListener("resize", this.resizeMap);
    this.clearScheduledMapResizes();
    this.clearScheduledRouteFits();
    if (this.mapResizeObserver) {
      this.mapResizeObserver.disconnect();
      this.mapResizeObserver = null;
    }
    this.stopPlayback();
    if (this.map) {
      this.map.dispose();
      this.map = null;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.timeZoneId !== this.props.timeZoneId) {
      const tzName = getSelectedTimeZone(this.state.tzName);
      this.setState({ tzName }, () => {
        if (this.state.assetId && this.state.records.length) {
          this.loadReplay();
        }
      });
      return;
    }

    if (prevProps.location.search !== this.props.location.search) {
      const values = queryString.parse(this.props.location.search);
      const selectedDate = values.selectedDate || values.SearchDate || values.searchDate || values.assetDate || moment().format("YYYY-MM-DD");
      this.setState(
        {
          assetId: values.assetId || values.AssetId || values.id || "",
          assetName: values.assetName || values.AssetName || values.name || "",
          selectedDate,
          date: moment(selectedDate).isValid() ? moment(selectedDate).toDate() : new Date(),
          calendarSelectedDate: moment(selectedDate).isValid() ? moment(selectedDate).toDate() : new Date(),
          dataPlaceholder: moment(selectedDate).isValid() ? moment(selectedDate).format("dddd Do MMMM, YYYY") : moment().format("dddd Do MMMM, YYYY"),
          groupId: values.groupId || values.GroupId || this.state.groupId,
          tzName: getSelectedTimeZone(values.tz || values.timeZone || this.state.tzName),
        },
        this.loadReplay
      );
    }

    if (prevState.records !== this.state.records || prevState.stops !== this.state.stops || prevState.depot !== this.state.depot) {
      this.renderMapObjects(true);
    } else if (prevState.selectedStopIndex !== this.state.selectedStopIndex) {
      this.renderMapObjects(false);
    } else if (
      prevState.erpGeofences !== this.state.erpGeofences
      || prevState.erpMatches !== this.state.erpMatches
      || prevState.erpOverlayVisible !== this.state.erpOverlayVisible
      || prevState.selectedErpStopIndex !== this.state.selectedErpStopIndex
    ) {
      this.renderErpMapObjects();
    } else if (prevState.currentIndex !== this.state.currentIndex) {
      this.updateMovingMarker();
    }
  }

  initMap = () => {
    if (!window.H || !document.getElementById("replayHereMap")) {
      this.setState({ errorMessage: "HERE Maps is still loading. Refresh the page if the map does not appear." });
      return;
    }

    this.platform = new window.H.service.Platform({ apikey: here_api_key });
    const layers = this.platform.createDefaultLayers({
      engineType: window.H.Map.EngineType && window.H.Map.EngineType.HARP,
    });

    this.map = new window.H.Map(document.getElementById("replayHereMap"), layers.vector.normal.map, {
      engineType: window.H.Map.EngineType && window.H.Map.EngineType.HARP,
      center: { lat: -37.81, lng: 144.96 },
      zoom: 7,
      pixelRatio: window.devicePixelRatio || 1,
    });

    new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(this.map));
    this.mapUi = window.H.ui.UI.createDefault(this.map, layers);
    this.map.addEventListener("mapviewchangeend", this.updateZoomLevel);
    window.addEventListener("resize", this.resizeMap);
    this.setState({ mapReady: true }, () => {
      this.scheduleMapResize();
      this.renderMapObjects(true);
    });
  };

  setMapContainerRef = (element) => {
    this.mapContainer = element;
    this.bindMapResizeObserver();
  };

  bindMapResizeObserver = () => {
    if (this.mapResizeObserver) {
      this.mapResizeObserver.disconnect();
      this.mapResizeObserver = null;
    }

    if (!this.mapContainer || typeof window.ResizeObserver === "undefined") return;

    this.mapResizeObserver = new window.ResizeObserver(() => {
      this.scheduleMapResize();
    });
    this.mapResizeObserver.observe(this.mapContainer);
  };

  clearScheduledMapResizes = () => {
    this.mapResizeTimers.forEach((timer) => window.clearTimeout(timer));
    this.mapResizeTimers = [];
  };

  clearScheduledRouteFits = () => {
    this.routeFitTimers.forEach((timer) => window.clearTimeout(timer));
    this.routeFitTimers = [];
  };

  scheduleMapResize = () => {
    this.clearScheduledMapResizes();
    this.resizeMap();

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(() => {
        this.resizeMap();
        window.requestAnimationFrame(this.resizeMap);
      });
    }

    [80, 180, 360, 700, 1100].forEach((delay) => {
      this.mapResizeTimers.push(window.setTimeout(this.resizeMap, delay));
    });
  };

  scheduleRouteFit = () => {
    this.clearScheduledRouteFits();
    this.resizeMap();
    this.fitRouteToVisibleMap();
    [120, 300, 650, 1050].forEach((delay) => {
      this.routeFitTimers.push(window.setTimeout(() => {
        this.resizeMap();
        this.fitRouteToVisibleMap();
      }, delay));
    });
  };

  resizeMap = () => {
    if (this.map) this.map.getViewPort().resize();
  };

  updateZoomLevel = () => {
    if (this.map) this.setState({ zoomLevel: Math.round(this.map.getZoom()) });
  };

  loadGroups = async () => {
    this.setState({ groupLoader: true });
    try {
      const response = await axios.post(
        `${apiHost}/api/Notification/AllGroupForNotification`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({ groupDetails: response.data || [], groupLoader: false });

      if (this.state.groupId) {
        this.getAssets(this.state.groupId);
      }
    } catch (error) {
      if (error && error.response && error.response.status === 401) {
        this.props.history.push("/login");
      } else {
        this.setState({ errorMessage: `${error}` });
      }
      this.setState({ groupLoader: false });
    }
  };

  getAssets = async (groupId) => {
    if (!groupId) return;

    this.setState({ assetLoader: true });
    try {
      const response = await axios.get(`${apiHost}/api/Notification/AssetsByGroupId/${groupId}?IsReport=true`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      this.setState({
        AssetList: response.data && response.data.paggedlist ? response.data.paggedlist : [],
        assetLoader: false,
      });
    } catch (error) {
      if (error && error.response && error.response.status === 401) {
        this.props.history.push("/login");
      } else {
        this.setState({ errorMessage: `${error}` });
      }
      this.setState({ assetLoader: false });
    }
  };

  handleGroupSelection = (selectedGroup) => {
    if (!selectedGroup) {
      this.groupId = "";
      this.setState({
        groupId: "",
        assetId: "",
        assetName: "",
        AssetList: [],
      });
      return;
    }

    const group = selectedGroup.data;
    this.groupId = group.groupId;
    this.setState({
      groupId: group.groupId,
      assetId: "",
      assetName: "",
      AssetList: [],
    });
    this.getAssets(group.groupId);
  };

  handleAssetSelection = (selectedAsset) => {
    if (!selectedAsset) {
      this.setState({
        assetId: "",
        assetName: "",
      });
      return;
    }

    const asset = selectedAsset.data;
    this.setState({
      assetId: asset.assetId,
      assetName: asset.name,
    });
  };

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ calendarShow: false });
    }
  };

  calendarFunction = () => {
    this.setState({ calendarShow: !this.state.calendarShow });
  };

  onChangeDate = (date) => {
    this.setState({
      date,
      calendarSelectedDate: date,
      selectedDate: moment(date).format("YYYY-MM-DD"),
      dataPlaceholder: moment(date).format("dddd Do MMMM, YYYY"),
      calendarShow: false,
    });
  };

  loadReplay = async () => {
    if (!this.state.assetId) return;
    const tzName = getSelectedTimeZone(this.state.tzName);

    this.stopPlayback();
    this.clearMapObjects();
    this.setState({
      isLoading: true,
      errorMessage: "",
      records: [],
      stops: [],
      depot: null,
      currentIndex: 0,
      selectedStopIndex: null,
      erpEnabled: false,
      erpMapped: false,
      erpLoading: true,
      erpError: "",
      erpStops: [],
      erpGeofences: [],
      erpMatches: {},
      activeStopsTab: "stops",
      selectedErpStopIndex: null,
    });

    try {
      const response = await axios.get(`${apiHost}/api/Report/Replay`, {
        params: {
          assetId: this.state.assetId,
          selectedDate: this.state.selectedDate,
          tz: tzName,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      const data = response.data || {};
      if (data.ok === false || data.Ok === false) {
        throw new Error(data.error || data.Error || "Replay data could not be loaded.");
      }

      const records = (data.records || data.Records || []).map((record) => ({
        ...record,
        lat: record.lat ?? record.Lat,
        lng: record.lng ?? record.Lng,
        speedKph: record.speedKph ?? record.SpeedKph,
        heading: record.heading ?? record.Heading,
        createdLocal: record.createdLocal ?? record.CreatedLocal,
        createdUtc: record.createdUtc ?? record.CreatedUtc,
        tSec: record.tSec ?? record.TSec,
        ign: record.ign ?? record.Ign,
        fridge: record.fridge ?? record.Fridge,
        tripKm: record.tripKm ?? record.TripKm,
        odoKm: record.odoKm ?? record.OdoKm,
        volts: record.volts ?? record.Volts,
        tempA: record.tempA ?? record.TempA,
        tempB: record.tempB ?? record.TempB,
        doorSensorStatus: record.doorSensorStatus ?? record.DoorSensorStatus ?? record.io2 ?? record.IO2,
        messageId: record.messageId ?? record.MessageId,
        messageDescription: record.messageDescription ?? record.MessageDescription,
        gpsValid: record.gpsValid ?? record.GpsValid,
        satellites: record.satellites ?? record.Satellites,
        driverName: record.driverName ?? record.DriverName ?? "",
        driverEventType: record.driverEventType ?? record.DriverEventType ?? "",
        driverStartedAtUtc: record.driverStartedAtUtc ?? record.DriverStartedAtUtc ?? "",
      }));

      const replayData = {
        ...data,
        assetName: data.assetName || data.AssetName || this.state.assetName,
        friendlyName: data.friendlyName || data.FriendlyName || "",
        tempA: data.tempA ?? data.TempA ?? false,
        tempB: data.tempB ?? data.TempB ?? false,
        doorSensor: data.doorSensor ?? data.DoorSensor ?? false,
        tzName: data.tzName || data.TzName || tzName,
      };
      const depot = data.depot || data.Depot || null;
      const stops = this.buildStops(records, VIRTUAL_STOP_MINUTES, replayData.tzName);

      this.setState(
        {
          records,
          stops,
          replayData,
          depot,
          loadedReportParams: {
            assetId: this.state.assetId,
            selectedDate: this.state.selectedDate,
            groupId: this.state.groupId,
          },
          assetName: replayData.assetName,
          tzName: replayData.tzName,
          isLoading: false,
          pickerExpanded: false,
        },
        () => {
          this.scheduleMapResize();
          this.loadStopAddresses(stops);
          this.loadErpReplayOverlay(records);
        }
      );
    } catch (error) {
      if (error && error.response && error.response.status === 401) {
        this.props.history.push("/login");
        return;
      }
      this.setState({
        isLoading: false,
        erpLoading: false,
        errorMessage: error.message || `${error}`,
      });
    }
  };

  loadErpReplayOverlay = async (records) => {
    const assetId = this.state.assetId;
    const selectedDate = this.state.selectedDate;
    try {
      const response = await axios.get(`${apiHost}/api/RunSheets/realtime-overlay`, {
        params: { assetId, runDate: selectedDate, fallback: false },
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      });
      if (String(this.state.assetId) !== String(assetId) || this.state.selectedDate !== selectedDate) return;
      const data = response.data || {};
      const erpStops = (data.stops || data.Stops || [])
        .slice()
        .sort((a, b) => Number(a.dropNumber ?? a.DropNumber) - Number(b.dropNumber ?? b.DropNumber));
      const erpGeofences = data.geofences || data.Geofences || [];
      this.setState({
        erpEnabled: !!(data.enabled ?? data.Enabled),
        erpMapped: !!(data.mapped ?? data.Mapped),
        erpLoading: false,
        erpError: "",
        erpStops,
        erpGeofences,
        erpMatches: this.matchErpStopsToReplay(records, erpGeofences, erpStops),
      });
    } catch (error) {
      if (String(this.state.assetId) !== String(assetId) || this.state.selectedDate !== selectedDate) return;
      if (error && error.response && error.response.status === 401) {
        this.props.history.push("/login");
        return;
      }
      this.setState({
        erpLoading: false,
        erpError: "Runsheet data could not be loaded. Replay remains available.",
      });
    }
  };

  matchErpStopsToReplay = (records, geofences, erpStops) => {
    const matches = {};
    (geofences || []).forEach((geofence) => {
      const lat = Number(geofence.lat ?? geofence.Lat);
      const lng = Number(geofence.lng ?? geofence.Lng);
      const radiusM = Math.max(50, Number(geofence.radiusM ?? geofence.RadiusM) || 0);
      const firstDrop = Number(geofence.firstDrop ?? geofence.FirstDrop);
      if (!Number.isFinite(lat) || !Number.isFinite(lng) || !Number.isFinite(firstDrop)) return;

      const insideIndexes = [];
      (records || []).forEach((record, index) => {
        const recordLat = getRecordLat(record);
        const recordLng = getRecordLng(record);
        if (!Number.isFinite(recordLat) || !Number.isFinite(recordLng)) return;
        if (haversineMeters(recordLat, recordLng, lat, lng) <= radiusM) insideIndexes.push(index);
      });

      const firstIndex = insideIndexes.length ? insideIndexes[0] : null;
      const lastIndex = insideIndexes.length ? insideIndexes[insideIndexes.length - 1] : null;
      const stopped = insideIndexes.length > 0 && this.state.stops.some((stop) => (
        stop.type === "real"
        && insideIndexes.some((index) => index >= Number(stop.startIdx) && index <= Number(stop.endIdx))
      ));
      const match = {
        status: stopped ? "stopped" : insideIndexes.length ? "visited" : "pending",
        firstIndex,
        lastIndex,
        arrivedAt: firstIndex !== null ? records[firstIndex].createdUtc || records[firstIndex].createdLocal : null,
        departedAt: lastIndex !== null ? records[lastIndex].createdUtc || records[lastIndex].createdLocal : null,
      };
      const geofenceStops = (erpStops || []).filter((stop) => {
        const stopLat = Number(stop.latitude ?? stop.Latitude);
        const stopLng = Number(stop.longitude ?? stop.Longitude);
        return Number.isFinite(stopLat) && Number.isFinite(stopLng)
          && haversineMeters(stopLat, stopLng, lat, lng) < 1;
      });
      if (!geofenceStops.length) matches[String(firstDrop)] = match;
      geofenceStops.forEach((stop) => {
        matches[String(stop.dropNumber ?? stop.DropNumber)] = match;
      });
    });
    return matches;
  };

  loadStopAddresses = async (stops) => {
    const updatedStops = await Promise.all(
      stops.map(async (stop) => {
        if (!Number.isFinite(stop.lat) || !Number.isFinite(stop.lng)) return { ...stop, geocodeDone: true };
        const result = await locationCache.getAddressDetails(stop.lat, stop.lng);
        return {
          ...stop,
          address: result && result.address ? result.address : "",
          addressSource: result && result.source ? result.source : "",
          geocodeDone: true,
        };
      })
    );
    this.setState({ stops: updatedStops });
  };

  buildStops = (records, virtualStopMinutes, tzName) => {
    const stops = [];
    if (!records.length) return stops;

    const addStop = (startIdx, endIdx, type) => {
      const start = records[startIdx];
      const end = records[endIdx];
      stops.push({
        type,
        startIdx,
        endIdx,
        tStart: Number(start.tSec || 0),
        tEnd: Number(end.tSec || start.tSec || 0),
        durationSec: Math.max(0, Math.round(Number(end.tSec || start.tSec || 0) - Number(start.tSec || 0))),
        lat: getRecordLat(start),
        lng: getRecordLng(start),
        overnight: false,
        isCurrent: false,
        geocodeDone: false,
      });
    };

    let inStop = Number(records[0].ign) === 0;
    let stopStartIdx = inStop ? 0 : null;

    records.forEach((record, index) => {
      const ign = Number(record.ign);
      const messageId = Number(record.messageId);
      if (!inStop && (ign === 0 || messageId === 5)) {
        inStop = true;
        stopStartIdx = index;
      }
      if (inStop && (ign === 1 || messageId === 4)) {
        addStop(stopStartIdx, index, "real");
        inStop = false;
        stopStartIdx = null;
      }
      if (index === records.length - 1 && inStop) {
        addStop(stopStartIdx, index, "real");
      }
    });

    if (stops[0] && stops[0].type === "real" && stops[0].startIdx === 0 && Number(records[0].ign) === 0) {
      stops[0].overnight = true;
    }

    const inRealStop = new Array(records.length).fill(false);
    stops.forEach((stop) => {
      if (stop.type !== "real") return;
      for (let i = stop.startIdx; i <= stop.endIdx; i += 1) inRealStop[i] = true;
    });

    const virtualLimitSec = Number(virtualStopMinutes) * 60;
    if (virtualLimitSec > 0) {
      let winStart = null;
      records.forEach((record, index) => {
        const eligible = Number(record.speedKph || 0) < 3 && Number(record.ign) === 1 && !inRealStop[index];
        if (eligible && winStart === null) winStart = index;
        if ((!eligible || index === records.length - 1) && winStart !== null) {
          const endIdx = eligible && index === records.length - 1 ? index : index - 1;
          const duration = Number(records[endIdx].tSec || 0) - Number(records[winStart].tSec || 0);
          if (duration >= virtualLimitSec) addStop(winStart, endIdx, "virtual");
          winStart = null;
        }
      });
    }

    const today = moment().tz(tzName || "Australia/Melbourne").format("YYYY-MM-DD");
    const lastRecord = records[records.length - 1];
    if (Number(lastRecord.ign) === 0) {
      const lastRealStop = [...stops].reverse().find((stop) => stop.type === "real" && stop.endIdx === records.length - 1);
      if (lastRealStop) {
        if (this.state.selectedDate === today) lastRealStop.isCurrent = true;
        else lastRealStop.overnight = true;
      }
    }

    return stops.sort((a, b) => a.tStart - b.tStart);
  };

  clearErpMapObjects = () => {
    if (this.map && this.erpMapObjects.length) this.map.removeObjects(this.erpMapObjects);
    this.erpMapObjects = [];
  };

  getErpMarkerSvg = (geofence, selected) => {
    const dropNumber = geofence.firstDrop ?? geofence.FirstDrop;
    const customerName = String(geofence.customerName ?? geofence.CustomerName ?? `Drop ${dropNumber}`).trim();
    const shortName = customerName.length > 24 ? `${customerName.slice(0, 22)}…` : customerName;
    const border = selected ? "#1d4ed8" : "#ea580c";
    return `<svg xmlns="http://www.w3.org/2000/svg" width="184" height="38" viewBox="0 0 184 38">
      <rect x="1" y="1" width="182" height="32" rx="8" fill="white" stroke="${border}" stroke-width="${selected ? 3 : 2}"/>
      <circle cx="18" cy="17" r="12" fill="#f97316"/>
      <text x="18" y="21" text-anchor="middle" font-family="Arial,sans-serif" font-size="10" font-weight="700" fill="white">${escapeMarkup(dropNumber)}</text>
      <text x="36" y="21" font-family="Arial,sans-serif" font-size="11" font-weight="700" fill="#17233c">${escapeMarkup(shortName)}</text>
      <path d="M14 33 L22 33 L18 38 Z" fill="${border}"/>
    </svg>`;
  };

  renderErpMapObjects = () => {
    this.clearErpMapObjects();
    if (!this.map || !this.state.erpEnabled || !this.state.erpMapped || !this.state.erpOverlayVisible) return;

    (this.state.erpGeofences || []).forEach((geofence) => {
      const lat = Number(geofence.lat ?? geofence.Lat);
      const lng = Number(geofence.lng ?? geofence.Lng);
      const radiusM = Math.max(50, Number(geofence.radiusM ?? geofence.RadiusM) || 0);
      const dropNumber = Number(geofence.firstDrop ?? geofence.FirstDrop);
      if (!Number.isFinite(lat) || !Number.isFinite(lng) || !Number.isFinite(dropNumber)) return;
      const stopIndex = this.state.erpStops.findIndex((stop) => Number(stop.dropNumber ?? stop.DropNumber) === dropNumber);
      const selected = stopIndex >= 0 && this.state.selectedErpStopIndex === stopIndex;
      const match = this.state.erpMatches[String(dropNumber)];
      const circle = new window.H.map.Circle({ lat, lng }, radiusM, {
        style: {
          fillColor: match && match.status === "stopped" ? "rgba(34,197,94,0.16)" : "rgba(249,115,22,0.13)",
          strokeColor: match && match.status === "stopped" ? "rgba(22,163,74,0.9)" : "rgba(234,88,12,0.9)",
          lineWidth: selected ? 4 : 2,
        },
      });
      const marker = new window.H.map.Marker(
        { lat, lng },
        {
          icon: new window.H.map.Icon(this.getErpMarkerSvg(geofence, selected), {
            anchor: { x: 18, y: 38 },
          }),
        }
      );
      if (stopIndex >= 0) {
        circle.addEventListener("tap", () => this.selectErpStop(stopIndex));
        marker.addEventListener("tap", () => this.selectErpStop(stopIndex));
      }
      this.map.addObjects([circle, marker]);
      this.erpMapObjects.push(circle, marker);
    });
  };

  selectErpStop = (index) => {
    const stop = this.state.erpStops[index];
    if (!stop) return;
    const dropNumber = Number(stop.dropNumber ?? stop.DropNumber);
    const match = this.state.erpMatches[String(dropNumber)];
    const lat = Number(stop.latitude ?? stop.Latitude);
    const lng = Number(stop.longitude ?? stop.Longitude);
    this.stopPlayback();
    this.setState({ selectedErpStopIndex: index, activeStopsTab: "runsheet" }, () => {
      if (match && Number.isFinite(match.firstIndex)) this.moveToIndex(match.firstIndex, false);
      if (this.map && Number.isFinite(lat) && Number.isFinite(lng)) {
        this.map.setCenter({ lat, lng }, false);
        if (this.map.getZoom() < 15) this.map.setZoom(15, false);
      }
    });
  };

  clearMapObjects = () => {
    if (!this.map) return;
    const objects = [this.routeLine, this.depotOverlay, this.movingMarker, ...this.stopMarkers].filter(Boolean);
    if (objects.length) this.map.removeObjects(objects);
    this.clearErpMapObjects();
    this.routeLine = null;
    this.depotOverlay = null;
    this.movingMarker = null;
    this.stopMarkers = [];
  };

  drawDepotOverlay = () => {
    const depot = this.state.depot;
    if (!this.map || !depot) return;

    const depotType = String(depot.depotType || depot.DepotType || "").toLowerCase();
    const center = depot.center || depot.Center;
    const locations = depot.locations || depot.Locations || [];
    const style = {
      fillColor: "rgba(37, 99, 235, 0.16)",
      strokeColor: "rgba(37, 99, 235, 0.9)",
      lineWidth: 3,
    };

    if (depotType === "circle" && center) {
      const lat = Number(center.latitude ?? center.Latitude);
      const lng = Number(center.longitude ?? center.Longitude);
      const radius = Number(depot.radius ?? depot.Radius);
      if (Number.isFinite(lat) && Number.isFinite(lng) && Number.isFinite(radius) && radius > 0) {
        this.depotOverlay = new window.H.map.Circle({ lat, lng }, radius, { style });
      }
    } else if ((depotType === "polygon" || depotType === "rectangle") && locations.length >= 3) {
      const points = locations
        .map((location) => ({
          lat: Number(location.latitude ?? location.Latitude),
          lng: Number(location.longitude ?? location.Longitude),
        }))
        .filter((point) => Number.isFinite(point.lat) && Number.isFinite(point.lng));

      if (points.length >= 3) {
        const lineString = new window.H.geo.LineString();
        points.forEach((point) => lineString.pushPoint(point));
        lineString.pushPoint(points[0]);
        this.depotOverlay = new window.H.map.Polygon(lineString, { style });
      }
    }

    if (this.depotOverlay) {
      this.depotOverlay.addEventListener("pointerenter", this.showDepotLabel);
      this.depotOverlay.addEventListener("pointermove", this.showDepotLabel);
      this.depotOverlay.addEventListener("pointerleave", this.hideDepotLabel);
      this.map.addObject(this.depotOverlay);
    }
  };

  showDepotLabel = (event) => {
    if (!this.map || !this.mapUi || !event || !event.currentPointer) return;
    const depot = this.state.depot || {};
    const depotName = depot.depotName || depot.DepotName;
    if (!depotName) return;

    const position = this.map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
    if (!position) return;
    const content = `<div class="replay-depot-label">${String(depotName).replace(/[&<>"']/g, (character) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    }[character]))}</div>`;

    if (!this.depotInfoBubble) {
      this.depotInfoBubble = new window.H.ui.InfoBubble(position, {
        content,
      });
      this.mapUi.addBubble(this.depotInfoBubble);
    } else {
      this.depotInfoBubble.setPosition(position);
      this.depotInfoBubble.setContent(content);
      this.depotInfoBubble.open();
    }
  };

  hideDepotLabel = () => {
    if (this.depotInfoBubble) {
      this.depotInfoBubble.close();
    }
  };

  renderMapObjects = (shouldFitRoute = false) => {
    if (!this.map || !this.state.mapReady) return;
    this.scheduleMapResize();
    this.clearMapObjects();
    this.drawDepotOverlay();
    this.renderErpMapObjects();
    const points = this.state.records
      .map((record) => ({ lat: getRecordLat(record), lng: getRecordLng(record) }))
      .filter((point) => Number.isFinite(point.lat) && Number.isFinite(point.lng));

    if (!points.length) return;

    const lineString = new window.H.geo.LineString();
    points.forEach((point) => lineString.pushPoint(point));
    this.routeLine = new window.H.map.Polyline(lineString, {
      style: { strokeColor: "rgba(239,68,68,0.9)", lineWidth: 4 },
    });
    this.map.addObject(this.routeLine);

    const stopLabels = this.getStopDisplayLabels(this.state.stops);
    this.stopMarkers = this.state.stops
      .filter((stop) => Number.isFinite(stop.lat) && Number.isFinite(stop.lng))
      .map((stop, index) => {
        const marker = new window.H.map.Marker(
          { lat: stop.lat, lng: stop.lng },
          { icon: this.getStopMarkerIcon(stop, stopLabels[index]) }
        );
        marker.addEventListener("tap", () => this.selectStop(index));
        this.map.addObject(marker);
        return marker;
      });

    const current = this.state.records[this.state.currentIndex] || this.state.records[0];
    const lat = getRecordLat(current);
    const lng = getRecordLng(current);
    if (Number.isFinite(lat) && Number.isFinite(lng)) {
      this.movingMarker = new window.H.map.Marker(
        { lat, lng },
        { icon: this.getMovingMarkerIcon(current) }
      );
      this.map.addObject(this.movingMarker);
    }

    if (shouldFitRoute && this.state.currentIndex === 0) {
      this.scheduleRouteFit();
      this.updateZoomLevel();
      this.scheduleMapResize();
    }
  };

  fitRouteToVisibleMap = () => {
    if (!this.map || !this.routeLine) return;
    const bounds = this.routeLine.getBoundingBox();
    if (!bounds) return;
    const expandedBounds = this.getExpandedRouteBounds(bounds);

    this.map.getViewModel().setLookAtData({
      bounds: expandedBounds,
      padding: { top: 72, right: 92, bottom: 104, left: 92 },
      tilt: 0,
    });
  };

  getExpandedRouteBounds = (bounds) => {
    const top = typeof bounds.getTop === "function" ? bounds.getTop() : bounds.top;
    const bottom = typeof bounds.getBottom === "function" ? bounds.getBottom() : bounds.bottom;
    const left = typeof bounds.getLeft === "function" ? bounds.getLeft() : bounds.left;
    const right = typeof bounds.getRight === "function" ? bounds.getRight() : bounds.right;

    if (![top, bottom, left, right].every(Number.isFinite)) return bounds;

    const latSpan = Math.max(Math.abs(top - bottom), 0.006);
    const lngSpan = Math.max(Math.abs(right - left), 0.006);
    const latPadding = Math.max(latSpan * 0.22, 0.003);
    const lngPadding = Math.max(lngSpan * 0.22, 0.003);

    return new window.H.geo.Rect(
      Math.min(90, top + latPadding),
      Math.max(-180, left - lngPadding),
      Math.max(-90, bottom - latPadding),
      Math.min(180, right + lngPadding)
    );
  };

  getStopMarkerIcon = (stop, label) => new window.H.map.Icon(this.getStopMarkerSvg(stop, label), {
    anchor: { x: 17, y: 17 },
  });

  getMovingMarkerIcon = (record) => new window.H.map.Icon(this.getMovingMarkerSvg(record.heading), {
    anchor: { x: 19, y: 19 },
  });

  updateMovingMarker = () => {
    if (!this.map) return;
    const record = this.state.records[this.state.currentIndex];
    const lat = getRecordLat(record);
    const lng = getRecordLng(record);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

    if (!this.movingMarker) {
      this.movingMarker = new window.H.map.Marker(
        { lat, lng },
        { icon: this.getMovingMarkerIcon(record) }
      );
      this.map.addObject(this.movingMarker);
      return;
    }

    this.movingMarker.setGeometry({ lat, lng });
    this.movingMarker.setIcon(this.getMovingMarkerIcon(record));
  };

  getStopMarkerSvg = (stop, label) => {
    const selected = this.state.stops[this.state.selectedStopIndex] === stop;
    const fill = stop.type === "real" ? "#ef4444" : "#f97316";
    const stroke = selected ? "#60a5fa" : "#ffffff";
    const width = selected ? 5 : 3;
    const markerLabel = label || "";
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
      <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
        <circle cx="17" cy="17" r="13" fill="${fill}" stroke="${stroke}" stroke-width="${width}"/>
        <text x="17" y="22" font-size="13" font-family="Arial" text-anchor="middle" fill="#fff" font-weight="700">${markerLabel}</text>
      </svg>
    `)}`;
  };

  getMovingMarkerSvg = (heading) => {
    const rotation = Number.isFinite(Number(heading)) ? Number(heading) : 0;
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
      <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
        <circle cx="19" cy="19" r="12" fill="#2563eb" stroke="#fff" stroke-width="4"/>
        <path d="M19 6 L24 20 L19 17 L14 20 Z" fill="#fff" transform="rotate(${rotation} 19 19)"/>
      </svg>
    `)}`;
  };

  moveToIndex = (index, shouldPan = true, animate = true) => {
    this.clearScheduledRouteFits();
    const currentIndex = Math.max(0, Math.min(index, this.state.records.length - 1));
    this.setState({ currentIndex }, () => {
      const record = this.state.records[currentIndex];
      const lat = getRecordLat(record);
      const lng = getRecordLng(record);
      if (shouldPan && this.map && Number.isFinite(lat) && Number.isFinite(lng)) {
        this.map.setCenter({ lat, lng }, animate);
        if (this.map.getZoom() < 15) this.map.setZoom(15, animate);
      }
    });
  };

  scrubToIndex = (index) => {
    this.stopPlayback();
    this.clearScheduledRouteFits();
    const currentIndex = Math.max(0, Math.min(index, this.state.records.length - 1));
    this.setState({ currentIndex }, () => {
      const record = this.state.records[currentIndex];
      const lat = getRecordLat(record);
      const lng = getRecordLng(record);
      if (this.map && Number.isFinite(lat) && Number.isFinite(lng)) {
        this.map.setCenter({ lat, lng }, false);
        this.updateZoomLevel();
      }
    });
  };

  startPlayback = () => {
    if (!this.state.records.length || this.playbackTimer) return;
    this.clearScheduledRouteFits();
    const startIndex = this.state.currentIndex >= this.state.records.length - 1 ? 0 : this.state.currentIndex;
    this.moveToIndex(startIndex, true, false);
    this.setState({ isPlaying: true });
    this.playbackTimer = setInterval(() => {
      if (this.state.currentIndex >= this.state.records.length - 1) {
        this.stopPlayback();
        return;
      }
      this.moveToIndex(this.state.currentIndex + 1, true, false);
    }, Math.max(80, 500 / this.state.playbackSpeed));
  };

  stopPlayback = () => {
    if (this.playbackTimer) {
      clearInterval(this.playbackTimer);
      this.playbackTimer = null;
    }
    this.setState({ isPlaying: false });
  };

  togglePlayback = () => {
    if (this.state.isPlaying) this.stopPlayback();
    else this.startPlayback();
  };

  selectStop = (index) => {
    const stop = this.state.stops[index];
    if (!stop) return;
    this.stopPlayback();
    this.setState({ selectedStopIndex: index }, () => {
      this.moveToIndex(stop.startIdx, false);
      if (this.map && Number.isFinite(stop.lat) && Number.isFinite(stop.lng)) {
        this.map.setCenter({ lat: stop.lat, lng: stop.lng }, false);
        this.map.setZoom(16, false);
        this.updateZoomLevel();
      }
    });
  };

  handleDateChange = (event) => {
    this.setState({ selectedDate: event.target.value });
  };

  loadSelectedDate = () => {
    this.handleCreateReport();
  };

  togglePicker = () => {
    this.setState({ pickerExpanded: !this.state.pickerExpanded }, () => {
      this.scheduleMapResize();
    });
  };

  getQuickReportUrl = (path) => {
    const assetName = this.state.assetName || "";
    const tzName = getSelectedTimeZone(this.state.tzName);
    const params = new URLSearchParams({
      assetId: this.state.assetId,
      assetName,
      SearchDate: this.state.selectedDate,
      assetDate: this.state.selectedDate,
      selectedDate: this.state.selectedDate,
      tz: tzName,
    });

    if (this.state.groupId) {
      params.set("groupId", this.state.groupId);
    }

    return `${path}?${params.toString()}`;
  };

  openQuickReport = (path) => {
    if (!this.state.assetId) {
      return;
    }

    const href = this.getQuickReportUrl(path);
    const parentWindow = window.opener && !window.opener.closed ? window.opener : window;
    const reportWindow = parentWindow.open(href, "_blank");

    if (reportWindow) {
      reportWindow.focus();
      return;
    }

    window.open(href, "_blank");
  };

  handleCreateReport = () => {
    if (!this.state.assetId) return;
    const tzName = getSelectedTimeZone(this.state.tzName);
    const params = new URLSearchParams(this.props.location.search);
    params.set("assetId", this.state.assetId);
    params.set("assetName", this.state.assetName || "");
    params.set("selectedDate", this.state.selectedDate);
    params.set("tz", tzName);
    if (this.state.groupId) {
      params.set("groupId", this.state.groupId);
    }
    this.props.history.replace(`/Replay?${params.toString()}`);
    this.setState({ tzName }, this.loadReplay);
  };

  renderLiveDetailRow = (label, value, options = {}) => (
    <div className={`live-detail-row ${options.className || ""}`}>
      <span className="live-detail-label">{label}</span>
      <strong className="live-detail-value">{options.iconNode}{options.preserveBlank ? value : value || "-"}</strong>
      {options.meta && <small className="live-detail-meta">{options.meta}</small>}
    </div>
  );

  renderFridgeValue = (fridgeValue) => {
    const fridge = Number(fridgeValue);
    return (
      <span className={fridge === 1 ? "fridge-pill fridge-on" : "fridge-pill fridge-off"}>
        <i className="fa fa-snowflake-o" aria-hidden="true"></i> {fridge === 1 ? "ON" : "OFF"}
      </span>
    );
  };

  renderDoorSensorValue = (doorSensorValue) => {
    if (doorSensorValue === null || doorSensorValue === undefined || doorSensorValue === "") return "-";
    const isClosed = Number(doorSensorValue) === 1;
    return (
      <span className={`door-sensor-pill ${isClosed ? "door-sensor-closed" : "door-sensor-open"}`}>
        {isClosed ? "CLOSED" : "OPEN"}
      </span>
    );
  };

  renderVoltageValue = (volts) => {
    const value = Number(volts);
    if (!Number.isFinite(value)) return "-";
    return (
      <span className={value < 12 ? "voltage-value low-voltage" : "voltage-value"}>
        {value < 12 && <span className="voltage-warning-icon" title="Low voltage">⚠️</span>}
        {formatNumber(value, 1, " V")}
      </span>
    );
  };

  renderGpsDetailRow = (record, gpsLocked, lat, lng) => (
    <div className="live-detail-row gps-detail-row">
      <span className="live-detail-label">GPS:</span>
      <strong className="live-detail-value gps-detail-value">
        <span className="gps-satellite-group">
          <span className={gpsLocked ? "gps-state-globe valid" : "gps-state-globe invalid"} title={gpsLocked ? "GPS valid (A)" : "GPS invalid (V)"}>
            <i className="fa fa-globe" aria-hidden="true"></i>
          </span>
          <span className="gps-satellite-count">({record.satellites !== null && record.satellites !== undefined ? record.satellites : "-"})</span>
        </span>
        <span className="gps-position-group">
          <span className="gps-position-label">Position:</span>
          <span className="gps-position-text">{Number.isFinite(lat) && Number.isFinite(lng) ? `${lat.toFixed(6)}, ${lng.toFixed(6)}` : "-"}</span>
        </span>
      </strong>
    </div>
  );

  renderDistanceDetailRow = (record) => (
    <div className="live-detail-row distance-detail-row">
      <span className="live-detail-label">Trip:</span>
      <strong className="live-detail-value distance-detail-value">
        <span className="distance-trip-value">{formatNumber(record.tripKm, 1, " km")}</span>
        <span className="distance-odometer-group">
          <span className="distance-secondary-label">Odometer:</span>
          {formatNumber(record.odoKm, 1, " km")}
        </span>
      </strong>
    </div>
  );

  renderLiveAssetDetail = () => {
    const data = this.state.replayData || {};
    const record = this.state.records[this.state.currentIndex];
    const assetName = data.assetName || this.state.assetName || "Asset";
    const friendlyName = data.friendlyName || "";
    const showTempA = isTruthyFlag(data.tempA ?? data.TempA);
    const showTempB = isTruthyFlag(data.tempB ?? data.TempB);
    const showDoorSensor = isTruthyFlag(data.doorSensor ?? data.DoorSensor);

    if (!record) {
      return (
        <section className="ping-card live-detail-card replay-live-detail-card">
          <div className="live-asset-header">
            <div className="live-asset-title-row"><h2>Asset</h2></div>
            <div className="live-asset-identity">
              <span className="engine-park">P</span>
              <div>
                <strong>{assetName}</strong>
                {friendlyName && <p>{friendlyName}</p>}
              </div>
            </div>
          </div>
          <div className="replay-empty-detail">Load replay data to view ping details.</div>
        </section>
      );
    }

    const lat = getRecordLat(record);
    const lng = getRecordLng(record);
    const gpsValid = String(record.gpsValid || "").trim();
    const gpsLocked = gpsValid === "65" || gpsValid.toUpperCase() === "A";
    const state = Number(record.ign) === 1 ? "driving" : "parked";

    return (
      <section className="ping-card live-detail-card replay-live-detail-card">
        <div className="live-asset-header">
          <div className="live-asset-title-row">
            <h2>Asset</h2>
          </div>
          <div className="live-asset-identity">
            <span className={state === "driving" ? "engine-driving" : "engine-park"}>{state === "driving" ? "D" : "P"}</span>
            <div>
              <strong>{assetName}</strong>
              {friendlyName && <p>{friendlyName}</p>}
            </div>
          </div>
        </div>

        {this.renderLiveDetailRow("GPS Time:", formatDateTime(record.createdUtc || record.createdLocal, data.tzName || this.state.tzName), {
          iconNode: <span className={`asset-health-dot ${gpsLocked ? "online" : "offline"}`}></span>,
          className: "gps-time-detail-row",
        })}
        {this.renderLiveDetailRow("Speed:", formatNumber(record.speedKph, 1, " km/h"))}
        {this.renderLiveDetailRow("Heading:", formatHeading(record.heading))}
        {this.renderGpsDetailRow(record, gpsLocked, lat, lng)}
        {showTempA && this.renderLiveDetailRow("Temp A:", getValidTemperature(record.tempA) === null ? "" : formatNumber(record.tempA, 1, "°C"), {
          className: temperatureReadingClass(record.tempA),
          preserveBlank: true,
        })}
        {showTempB && this.renderLiveDetailRow("Temp B:", getValidTemperature(record.tempB) === null ? "" : formatNumber(record.tempB, 1, "°C"), {
          className: temperatureReadingClass(record.tempB),
          preserveBlank: true,
        })}
        {record.fridge !== null && record.fridge !== undefined && this.renderLiveDetailRow("Fridge:", this.renderFridgeValue(record.fridge))}
        {showDoorSensor && this.renderLiveDetailRow("Door:", this.renderDoorSensorValue(record.doorSensorStatus), {
          className: "door-sensor-detail-row",
        })}
        {this.renderDistanceDetailRow(record)}
        {this.renderLiveDetailRow("Volts:", this.renderVoltageValue(record.volts), {
          className: Number(record.volts) < 12 ? "volts-detail-row low-voltage" : "volts-detail-row",
        })}
        {this.renderLiveDetailRow("MessageID:", `${record.messageId || "-"}${record.messageDescription ? ` - ${record.messageDescription}` : ""}`)}

        <div className="live-refresh-meta">
          <span>Replay point {this.state.currentIndex + 1} of {this.state.records.length}</span>
        </div>
      </section>
    );
  };

  renderReplayDriverStatusCard = () => {
    const data = this.state.replayData || {};
    const record = this.state.records[this.state.currentIndex];
    if (!record || !record.driverName) return null;

    return (
      <section className="ping-card driver-status-card replay-driver-status-card">
        <div className="driver-status-icon" aria-hidden="true">
          <i className="fa fa-id-card-o"></i>
        </div>
        <div className="driver-status-content">
          <span>Driver</span>
          <strong>{record.driverName}</strong>
        </div>
        <div className="driver-status-event">
          <span>Start of Shift</span>
          <strong>{record.driverStartedAtUtc ? formatDateTime(record.driverStartedAtUtc, data.tzName || this.state.tzName) : "-"}</strong>
        </div>
      </section>
    );
  };

  getStopDisplayLabels = (stops) => {
    let stopCount = 0;
    return (stops || []).map((stop) => {
      if (isCarryInOvernightStop(stop)) return "";
      if (stop.type === "real" || stop.type === "virtual") {
        stopCount += 1;
        return stopCount;
      }
      return "";
    });
  };

  renderStopCard = (stop, index) => {
    const startRecord = this.state.records[stop.startIdx];
    const endRecord = this.state.records[stop.endIdx];
    const duration = `${Math.floor(stop.durationSec / 60)}m ${stop.durationSec % 60}s`;
    const isSelected = this.state.selectedStopIndex === index;
    const startTime = formatDateTime(startRecord && (startRecord.createdUtc || startRecord.createdLocal), this.state.tzName);
    const endTime = stop.isCurrent ? "Current" : formatDateTime(endRecord && (endRecord.createdUtc || endRecord.createdLocal), this.state.tzName);
    const address = stop.address || (stop.geocodeDone ? "Address unavailable" : "Looking up address...");
    const displayLabels = this.getStopDisplayLabels(this.state.stops);
    const displayLabel = displayLabels[index];
    const isCarryInOvernight = isCarryInOvernightStop(stop);
    const stopTitle = isCarryInOvernight ? "Overnight Event" : stop.type === "real" ? "Actual Stop" : "Virtual Stop";

    return (
      <button
        type="button"
        key={`${stop.type}-${stop.startIdx}-${stop.endIdx}`}
        className={`replay-stop-card ${stop.type} ${isCarryInOvernight ? "overnight-event" : ""} ${isSelected ? "selected" : ""}`}
        onClick={() => this.selectStop(index)}
      >
        <span className="replay-stop-header">
          {!isCarryInOvernight && <span className="replay-stop-badge">{displayLabel}</span>}
          <strong>
            {stopTitle}
            {stop.overnight && <em className="replay-stop-state-badge overnight">Overnight</em>}
            {stop.isCurrent && <em className="replay-stop-state-badge current">Current</em>}
          </strong>
        </span>
        <span className="replay-stop-body">
          <span><b>Start:</b> {startTime}</span>
          <span><b>End:</b> {endTime}</span>
          <span><b>Duration:</b> {duration}</span>
          <span><b>Address:</b> {address}</span>
        </span>
      </button>
    );
  };

  renderErpStopCard = (stop, index) => {
    const dropNumber = Number(stop.dropNumber ?? stop.DropNumber);
    const match = this.state.erpMatches[String(dropNumber)] || { status: "pending" };
    const lat = Number(stop.latitude ?? stop.Latitude);
    const lng = Number(stop.longitude ?? stop.Longitude);
    const hasCoordinates = Number.isFinite(lat) && Number.isFinite(lng) && lat !== 0 && lng !== 0;
    const customerName = stop.customerName ?? stop.CustomerName ?? stop.customerCode ?? stop.CustomerCode ?? `Drop ${dropNumber}`;
    const address = [
      stop.address1 ?? stop.Address1,
      stop.address2 ?? stop.Address2,
      stop.address3 ?? stop.Address3,
      stop.address4 ?? stop.Address4,
      stop.postcode ?? stop.Postcode,
    ].filter(Boolean).join(", ");
    const deliveryInstructions = stop.deliveryInstructions ?? stop.DeliveryInstructions;
    const isSelected = this.state.selectedErpStopIndex === index;
    const status = !hasCoordinates ? "missing" : match.status;
    const statusLabel = status === "stopped"
      ? "Stopped at customer location"
      : status === "visited"
        ? "Route entered customer geofence"
        : status === "missing"
          ? "Missing coordinates"
          : "No visit recorded";

    return (
      <button
        type="button"
        key={stop.id ?? stop.Id ?? `${dropNumber}-${stop.orderId ?? stop.OrderId ?? index}`}
        className={`replay-runsheet-card ${status} ${isSelected ? "selected" : ""}`}
        onClick={() => this.selectErpStop(index)}
      >
        <span className="replay-runsheet-header">
          <span className="replay-runsheet-drop">{dropNumber}</span>
          <strong>{customerName}</strong>
        </span>
        <span className="replay-runsheet-body">
          <span><b>Address:</b> {address || "Not supplied"}</span>
          {deliveryInstructions && deliveryInstructions !== "." && <span><b>Instructions:</b> {deliveryInstructions}</span>}
          {match.arrivedAt && <span><b>Arrival:</b> {formatDateTime(match.arrivedAt, this.state.tzName)}</span>}
          {match.departedAt && <span><b>Departure:</b> {formatDateTime(match.departedAt, this.state.tzName)}</span>}
          <span className={`replay-runsheet-status ${status}`}>{statusLabel}</span>
        </span>
      </button>
    );
  };

  renderErpStopsList = () => {
    if (this.state.erpLoading) return <p>Loading runsheet...</p>;
    if (this.state.erpError) return <p className="replay-runsheet-message error">{this.state.erpError}</p>;
    if (!this.state.erpMapped) return <p className="replay-runsheet-message">This asset is not mapped to an ERP vehicle.</p>;
    if (!this.state.erpStops.length) return <p className="replay-runsheet-message">No runsheet is available for the selected date.</p>;
    return this.state.erpStops
      .slice()
      .sort((a, b) => Number(a.dropNumber ?? a.DropNumber) - Number(b.dropNumber ?? b.DropNumber))
      .map(this.renderErpStopCard);
  };

  render() {
    const actualStops = this.state.stops.filter((stop) => stop.type === "real" && !isCarryInOvernightStop(stop)).length;
    const virtualStops = this.state.stops.filter((stop) => stop.type === "virtual").length;
    const currentRecord = this.state.records[this.state.currentIndex];
    const heading = currentRecord ? formatHeading(currentRecord.heading) : "-";
    const firstRecord = this.state.records[0];
    const lastRecord = this.state.records[this.state.records.length - 1];
    const stopDisplayLabels = this.getStopDisplayLabels(this.state.stops);
    const lastRecordIndex = Math.max(0, this.state.records.length - 1);
    const playbackTimeZone = this.state.replayData && this.state.replayData.tzName ? this.state.replayData.tzName : this.state.tzName;
    const formatPlaybackTime = (record) => {
      if (!record) return "-";
      const value = record.createdUtc || record.createdLocal;
      const date = moment(value);
      if (!date.isValid()) return "-";
      return playbackTimeZone ? date.tz(playbackTimeZone).format("HH:mm:ss") : date.format("HH:mm:ss");
    };
    const groupOptions = this.state.groupDetails.map((group) => ({
      label: `${group.customername} / ${group.groupName}`,
      value: group.groupId,
      data: group,
    }));
    const assetOptions = this.state.AssetList.map((asset) => ({
      label: `${asset.name}${asset.customerName ? ` / ${asset.customerName}` : ""}`,
      value: asset.assetId,
      data: asset,
    }));
    const selectedGroupOption = groupOptions.find((option) => option.value === this.state.groupId) || null;
    const selectedAssetOption = this.state.assetId
      ? {
          label: this.state.assetName || "Selected Asset",
          value: this.state.assetId,
          data: { assetId: this.state.assetId, name: this.state.assetName },
        }
      : null;
    const selectStyles = {
      menu: (provided) => ({ ...provided, zIndex: 20 }),
      control: (provided, state) => ({
        ...provided,
        minHeight: 38,
        backgroundColor: "#f8fafc",
        borderColor: state.isFocused ? "#244b8f" : "#d7e2f0",
        boxShadow: state.isFocused ? "0 0 0 2px rgba(36, 75, 143, 0.14)" : "none",
        fontSize: 13,
        "&:hover": {
          borderColor: state.isFocused ? "#244b8f" : "#aebdd0",
        },
      }),
      valueContainer: (provided) => ({ ...provided, fontSize: 13 }),
      placeholder: (provided) => ({ ...provided, color: "#7e8da1", fontSize: 13 }),
      singleValue: (provided) => ({ ...provided, color: "#17233c", fontSize: 13, fontWeight: 700 }),
      input: (provided) => ({ ...provided, color: "#17233c", fontSize: 13 }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? "#244b8f" : state.isFocused ? "#edf3fb" : "#fff",
        color: state.isSelected ? "#fff" : "#26354f",
        fontSize: 13,
      }),
    };
    const calendarReport = this.state.calendarShow ? (
      <div className="calendarWrapper" ref={this.setWrapperRef}>
        <Calendar maxDate={new Date()} onChange={this.onChangeDate} value={this.state.calendarSelectedDate} />
      </div>
    ) : (
      ""
    );
    const hasReplay = this.state.records.length > 0;
    const compactPicker = hasReplay && !this.state.pickerExpanded;
    const loadedReportParams = this.state.loadedReportParams;
    const hasPendingPickerChanges = !!(
      hasReplay &&
      loadedReportParams &&
      (
        loadedReportParams.assetId !== this.state.assetId ||
        loadedReportParams.selectedDate !== this.state.selectedDate ||
        (loadedReportParams.groupId || "") !== (this.state.groupId || "")
      )
    );

    return (
      <Layout>
        <Helmet>
          <title>Replay Report</title>
        </Helmet>
        <div className="contentBody">
          <div className="contentWrapper contentWrapperSmoothRelease report-modern-page replay-report-page">
            <div className={compactPicker ? "reportHeaderTile replay-header-tile compact" : "reportHeaderTile replay-header-tile"}>
              <div className="headingContainer report-modern-header">
                <div>
                  <h2 className="mainHeading">Replay Report</h2>
                  {!compactPicker && <p>{this.state.assetName ? `${this.state.assetName} - ${this.state.selectedDate}` : "Select an asset and date to generate replay."}</p>}
                </div>
                {hasReplay && (
                  <button
                    type="button"
                    className="replay-picker-toggle"
                    aria-label={this.state.pickerExpanded ? "Hide quick reports" : "Show quick reports"}
                    title={this.state.pickerExpanded ? "Hide quick reports" : "Show quick reports"}
                    onClick={this.togglePicker}
                  >
                    <i className={this.state.pickerExpanded ? "fa fa-compress" : "fa fa-sliders"} aria-hidden="true"></i>
                  </button>
                )}
              </div>

              <div className="inputFormGroup reportPickerGrid reportPickerToolbar replay-picker-toolbar">
                {!compactPicker && (
                  <div className="reportQuickActions">
                    <span className="reportQuickActionsLabel">Quick reports</span>
                    <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-MVTL")}>MVTL</button>
                    <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-Visit")}>Visit</button>
                    <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Temperature")}>Temp</button>
                    <button type="button" className="active" disabled={!this.state.assetId} onClick={() => this.handleCreateReport()}>Replay</button>
                    <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Rpt-LocationData")}>Location</button>
                    <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Timeline")}>Timeline</button>
                    <button type="button" disabled={!this.state.assetId} onClick={() => this.openQuickReport("/Track")}>Track</button>
                  </div>
                )}
                <div className="inputElement reportPickerField">
                  <label>Group</label>
                  <Select
                    value={selectedGroupOption}
                    options={groupOptions}
                    styles={selectStyles}
                    onChange={this.handleGroupSelection}
                    isClearable
                    isSearchable
                    isLoading={this.state.groupLoader}
                    placeholder="Search group"
                    noOptionsMessage={() => "No groups found"}
                  />
                </div>
                <div className="inputElement reportPickerField">
                  <label>Asset</label>
                  <Select
                    value={selectedAssetOption}
                    options={assetOptions}
                    styles={selectStyles}
                    onChange={this.handleAssetSelection}
                    isClearable
                    isSearchable
                    isDisabled={!this.state.groupId && !this.state.assetId}
                    isLoading={this.state.assetLoader}
                    placeholder={this.state.groupId || this.state.assetId ? "Search asset" : "Select group first"}
                    noOptionsMessage={() => "No assets found"}
                  />
                </div>
                <div className="inputElement reportPickerField">
                  <label>Date</label>
                  <ReportButtonGroup
                    function={this.calendarFunction}
                    dropDown={calendarReport}
                    placeholder={this.state.dataPlaceholder}
                    icon="fa-calendar"
                  />
                </div>
                <div className="inputElement reportPickerActions">
                  <Button
                    className={hasPendingPickerChanges ? "reportPickerCreateButton report-create-pending" : "reportPickerCreateButton"}
                    variant="primary"
                    onClick={this.handleCreateReport}
                    size="sm"
                    disabled={!this.state.assetId || this.state.isLoading}
                    title={hasPendingPickerChanges ? "Picker values have changed. Create the report to apply them." : undefined}
                  >
                    <i className="fa fa-play-circle"></i>
                    Create Report
                  </Button>
                </div>
              </div>
            </div>

            {this.state.errorMessage && <div className="replay-error">{this.state.errorMessage}</div>}

            <div className={`replay-main-grid ${!hasReplay ? "empty" : ""}`}>
              <aside className="replay-left-panel">
                <section className="replay-tile">
                  <h2>Stops Summary</h2>
                  <div className="replay-stop-counts">
                    <span><i className="actual"></i>{actualStops} actual stop{actualStops === 1 ? "" : "s"}</span>
                    <span><i className="virtual"></i>{virtualStops} virtual stop{virtualStops === 1 ? "" : "s"}</span>
                  </div>
                  <div className="replay-virtual-note">
                    Virtual stops use speed below 3 km/h for {VIRTUAL_STOP_MINUTES} minutes.
                  </div>
                </section>
                <section className="replay-tile replay-stops-list">
                  <div className="replay-stops-heading">
                    <h2>Stops / Visits</h2>
                    {this.state.erpEnabled && (
                      <div className="replay-stops-tabs" role="tablist" aria-label="Replay stop lists">
                        <button
                          type="button"
                          role="tab"
                          aria-selected={this.state.activeStopsTab === "stops"}
                          className={this.state.activeStopsTab === "stops" ? "active" : ""}
                          onClick={() => this.setState({ activeStopsTab: "stops" })}
                        >
                          Stops
                        </button>
                        <button
                          type="button"
                          role="tab"
                          aria-selected={this.state.activeStopsTab === "runsheet"}
                          className={this.state.activeStopsTab === "runsheet" ? "active" : ""}
                          onClick={() => this.setState({ activeStopsTab: "runsheet" })}
                        >
                          Runsheet
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="replay-stop-scroll">
                    {this.state.activeStopsTab === "runsheet" && this.state.erpEnabled
                      ? this.renderErpStopsList()
                      : this.state.stops.length
                        ? this.state.stops.map(this.renderStopCard)
                        : <p>No stops to display.</p>}
                  </div>
                </section>
              </aside>

              <main className="replay-map-panel">
                <div className="replay-map-shell">
                  <div className="replay-map-toolbar">
                    <button type="button" onClick={() => this.map && this.map.setZoom(this.map.getZoom() + 1)}>+</button>
                    <button type="button" onClick={() => this.map && this.map.setZoom(this.map.getZoom() - 1)}>-</button>
                  </div>
                  {this.state.erpEnabled && this.state.erpMapped && this.state.erpGeofences.length > 0 && (
                    <button
                      type="button"
                      className={`replay-erp-overlay-toggle ${this.state.erpOverlayVisible ? "active" : ""}`}
                      onClick={() => this.setState({ erpOverlayVisible: !this.state.erpOverlayVisible })}
                    >
                      <i className="fa fa-map-marker" aria-hidden="true"></i>
                      {this.state.erpOverlayVisible ? "Hide runsheet stops" : "Show runsheet stops"}
                    </button>
                  )}
                  <div className="replay-heading-card">
                    <span className="replay-heading-icon"></span>
                    <strong>Heading: {heading}</strong>
                  </div>
                  <div className="replay-zoom-display">Zoom: {this.state.zoomLevel}</div>
                  {this.state.isLoading && <div className="replay-map-loading">Loading replay...</div>}
                  {!hasReplay && !this.state.isLoading && <div className="replay-map-loading">Create a report to load replay.</div>}
                  <div id="replayHereMap" className="replay-here-map" ref={this.setMapContainerRef}></div>
                </div>

                <section className="replay-playback-panel">
                  <div className="replay-playback-row">
                    <div className="replay-playback-buttons">
                      <button type="button" onClick={() => this.moveToIndex(this.state.currentIndex - 1)}>
                        <i className="fa fa-step-backward" aria-hidden="true"></i>
                      </button>
                      <button type="button" className="play" onClick={this.togglePlayback}>
                        {this.state.isPlaying ? "Pause" : "Play"}
                      </button>
                      <button type="button" onClick={() => this.moveToIndex(this.state.currentIndex + 1)}>
                        <i className="fa fa-step-forward" aria-hidden="true"></i>
                      </button>
                    </div>
                    <label>
                      Speed
                      <select
                        value={this.state.playbackSpeed}
                        onChange={(event) => this.setState({ playbackSpeed: Number(event.target.value) }, () => {
                          if (this.state.isPlaying) {
                            this.stopPlayback();
                            this.startPlayback();
                          }
                        })}
                      >
                        <option value={0.5}>0.5x</option>
                        <option value={1}>1x</option>
                        <option value={2}>2x</option>
                        <option value={4}>4x</option>
                        <option value={8}>8x</option>
                      </select>
                    </label>
                  </div>
                  <div className="replay-timeline">
                    <div className="replay-timeline-stops" aria-label="Stops on replay timeline">
                      {this.state.stops.map((stop, index) => {
                        const label = stopDisplayLabels[index];
                        if (!label) return null;
                        const position = lastRecordIndex > 0
                          ? Math.max(0, Math.min(100, (Number(stop.startIdx) / lastRecordIndex) * 100))
                          : 0;
                        return (
                          <button
                            type="button"
                            key={`${stop.type}-${stop.startIdx}-${stop.endIdx}`}
                            className={`replay-timeline-stop ${stop.type} ${this.state.selectedStopIndex === index ? "selected" : ""}`}
                            style={{ left: `${position}%` }}
                            title={`${stop.type === "real" ? "Actual" : "Virtual"} Stop ${label} at ${formatPlaybackTime(this.state.records[stop.startIdx])}`}
                            aria-label={`Go to ${stop.type === "real" ? "actual" : "virtual"} stop ${label}`}
                            onClick={() => this.selectStop(index)}
                          >
                            {label}
                          </button>
                        );
                      })}
                    </div>
                    <input
                      type="range"
                      min="0"
                      max={lastRecordIndex}
                      value={this.state.currentIndex}
                      onChange={(event) => this.scrubToIndex(Number(event.target.value))}
                    />
                  </div>
                  <div className="replay-time-scale">
                    <span>{formatPlaybackTime(firstRecord)}</span>
                    <strong>{formatPlaybackTime(currentRecord)}</strong>
                    <span>{formatPlaybackTime(lastRecord)}</span>
                  </div>
                </section>
              </main>

              <aside className="replay-right-panel">
                <div className="replay-live-detail-heading">Replay Asset Details</div>
                {this.renderLiveAssetDetail()}
                {this.renderReplayDriverStatusCard()}
              </aside>
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  timeZoneId: state.timeZoneId,
});

export default connect(mapStateToProps)(Replay);
